'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAuthUser } from '@/lib/auth/common/useSession';

/**
 * Route-level auth redirect, gated on the server verdict (`isLoading`) rather than a
 * localStorage guess or timer. Not the security boundary — that's the Academy API per
 * request plus proxy.ts's cookie check — this only keeps a route from rendering for the
 * wrong audience.
 *
 * @param redirectPath where signed-out visitors go.
 */
export function useRequireAuth(redirectPath = '/') {
  const router = useRouter();
  const { isLoggedIn, isLoading } = useAuthUser();

  useEffect(() => {
    if (isLoading) return; // no verdict yet
    if (!isLoggedIn) router.replace(redirectPath);
  }, [isLoading, isLoggedIn, redirectPath, router]);

  // isAuthenticated is the verdict (safe to gate a query on); isLoading distinguishes
  // "not signed in" from "not known yet".
  return { isAuthenticated: isLoggedIn, isLoading };
}
